// moz667: por culpa de vrdemo
var $ = jQuery;

window.file_upload_init = function () {
    $(".file-upload").each(function () {
        var $this = $(this);
        var $img = $this.find(".img-wrap img");
        var $input_file = $this.find(".custom-file input");
        var $delete_file = $this.find("input.avatar-clear");

        $input_file.change(function () {
            $delete_file.prop('checked', false);
            input_file_load(this, $img);
        });

        $delete_file.change(function () {
            if($delete_file.prop('checked')) {
                $input_file.val("");
                input_file_load(this, $img);
                $this.find(".custom-file-label").html(n2m_i18n("Elige tu foto de perfil"));
            }
        });

        function input_file_load(input, $img) {
            if (FileReader) {
                if (input && input.files && input.files[0]) {
                    // Limite de 4 mb para las subidas de fotos
                    var filesize = ((input.files[0].size/1024)/1024).toFixed(4); // MB
                    if (filesize < 4) {
                        var reader = new FileReader();
                        console.log(input.files[0]);
                        reader.onload = function(e) {
                            $img.attr('src', e.target.result);
                            $this.find(".custom-file-label").html(input.files[0].name);
                        }

                        reader.readAsDataURL(input.files[0]); // convert to base64 string
                    } else {
                        alert(n2m_i18n("El archivo no puede ser mas grande que 4 MB. Escoja otro archivo mas pequeño."));
                        $this.find(".custom-file-label").html(n2m_i18n("Elige tu foto de perfil"));

                        $input_file.val("");
                        $img.attr('src', N2M.DEFAULT_PROFILE_IMG);
                    }
                } else {
                    // FIXME: Esta puesto a pelo para el perfil... parametrizar si lo usamos para otras cosas
                    $img.attr('src', N2M.DEFAULT_PROFILE_IMG);
                    $this.find(".custom-file-label").html(n2m_i18n("Elige tu foto de perfil"));
                }
            }
        }
    });
};
